import { createContext } from "react";

export const CalendarContext = createContext();

export const EventContext = createContext();

